import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyFlightsComponent } from 'src/app/flight/my-flights/my-flights.component';
import { ValidateCrewInfo } from 'src/app/models/ValidateCrewInfo';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { GoogleUser } from 'src/app/models/GoogleUser';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { PasseLivreLatamCrewService } from 'src/app/core/services/passe-livre/passe-livre-latam-crew.service';
import { AccessRestrictionDialogService } from 'src/app/shared/services/access-restriction-dialog.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(
    private passeLivreService: PasseLivreLatamCrewService,
    private googleAuthenticationService: GoogleAuthenticationService,
    private notificationService: NotificationService,
    private accessRestrictionDialogService: AccessRestrictionDialogService,
    private router: Router,
    private crewInfoStore: CrewInfoStore) {
      if (HomeComponent.instance) {
        return HomeComponent.instance;
      }
      HomeComponent.instance = this;
    }

  static instance: HomeComponent;
  alreadyExecuted: boolean = false;

  selectedIndex: number;
  readonly crewInfo = this.crewInfoStore.crewInfo;
  readonly crewInfoValidated = this.crewInfoStore.crewInfoValidated;

  ngOnInit(): void {
    this.selectTab();
    this.refresh();

    if (!this.alreadyExecuted) {
      this.validateCrewInfo();
      this.getCrewInfo();

      this.alreadyExecuted = true;
    }
  }

  private selectTab(): void {
    const tab = this.extractDataFromUrl('tab');

    if (tab) {
      const tabNumber = Number(tab);
      this.selectedIndex = tabNumber;
    } else {
      this.selectedIndex = 0;
    }
  }

  private refresh(): void {
    const refresh = this.extractDataFromUrl('refresh');

    if (refresh) {
      MyFlightsComponent.instance.refreshTickets();
    }
  }

  private extractDataFromUrl(param: string): string | undefined {
    const url = this.router.url;
    const match = url.match(RegExp(`${param}=(.+)`));

    if (match && match[1]) {
      return match[1];
    }

    return undefined;
  }

  private validateCrewInfo(): void {
    const googleUser: GoogleUser | null  = this.googleAuthenticationService.getGoogleUser();

    if (googleUser?.email) {
      this.passeLivreService.validateLatamCrew().subscribe({
        next: (crewInfoValidated: ValidateCrewInfo) => {
          this.crewInfoStore.setCrewInfoValidated(crewInfoValidated);
        },
        error: (resp: any) => {
          console.log(resp);
          const crewInfoValidated: ValidateCrewInfo = resp.error;

          if (resp.status != 403) {
            this.notificationService.error('Ocorreu um erro ao validar os dados do tripulante.');
            return;
          }

          const validated = new ValidateCrewInfo();
          validated.active = crewInfoValidated.active;
          validated.blocked = crewInfoValidated.blocked;
          validated.valid = crewInfoValidated.valid;
          validated.accessDeniedMessage = crewInfoValidated.accessDeniedMessage;
          validated.invalidFields = crewInfoValidated.invalidFields;

          this.crewInfoStore.setCrewInfoValidated(validated);
          this.accessRestrictionDialogService.open(crewInfoValidated);
        }
      });
    }
  }

  getCrewInfo(): void {
    const googleUser: GoogleUser | null  = this.googleAuthenticationService.getGoogleUser();

    if (googleUser?.email) {
      this.passeLivreService.getLatamCrew().subscribe({
        next: (crewInfo: CrewInfo) => {
          this.crewInfoStore.setCrewInfo(crewInfo);
        },
        error: () => {
          this.notificationService.error('Ocorreu um erro ao buscar os dados do tripulante.');
        }
      });
    }
  }

}
